import React, { Component } from 'react';
import Rating from '../../../components/common/rating'
import { Col,Row } from 'reactstrap';


class LBdescription extends Component {
    render() {
        return (
            <div className="disc-visa px-2 py-1">
                        <div className="d-flex justify-content-between align-items-center">

                            <h3
                              className="pt-2 pb-1 text-left"
                              style={{ fontWeight: "600" }}
                            >
                              L&B Tourism
                            </h3>
                      
                       
                          <div style={{marginRight:"-20px",marginTop: "9px"}} >
                            <Rating
                              starts={"3"}
                              color={"gold"}
                              change={false}
                              size={"1.4rem"}
                            />
                            </div>
                        </div>
                        <hr style={{ width: "100%", marginBottom: "0" }} />
                        <div>
                          <span className="font-weight-bold  pb-2 pt-2">
                            Description
                          </span>
                          <p className=" pb-3 desc-visa-p">
                            Lorly dummy text of the printing and typesetting
                            industry. Lorem Ipsum has been the industry's
                            standard dummy text ever since the 1500s, when an
                            unknown printer took a galley of type and scrambled
                            it to make a type specimen book. It has survived not
                            only five centuries, but also the leap into.
                          </p>
                        </div>
                      </div>
        );
    }
}

export default LBdescription;
